import React from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
// import Cart from './Cart';

const Header = () => {
  let navigate = useNavigate();

  return (
    <>
      <Navbar collapseOnSelect expand="lg">
        <Container>
          <Navbar.Brand href="#HOME">
            <Nav.Link onClick={() => { navigate('/') }}>
              KANGOL
            </Nav.Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link onClick={() => { navigate('/DETAIL/3') }}>MEN</Nav.Link>
              <Nav.Link onClick={() => { navigate('/DETAIL/0') }}>WOMEN</Nav.Link>
              <NavDropdown title="ALL" id="collasible-nav-dropdown">
                <NavDropdown.Item href="#BAG">BAG</NavDropdown.Item>
                <NavDropdown.Item href="#CLOTHES">
                  CLOTHES
                </NavDropdown.Item>
                <NavDropdown.Item href="#SHOES">SHOES</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={() => { navigate('/CART') }}>
                  MY KANGOL
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav className='nav-col'>
              <Nav.Link onClick={() => { navigate('/LOGIN') }}>
                <FontAwesomeIcon icon={faUser} className="icon_font" />
              </Nav.Link>
              <Nav.Link onClick={() => { navigate('/CART') }}>
                <FontAwesomeIcon icon={faCartShopping} className="icon_font" />
              </Nav.Link>
              <Nav.Link eventKey={2} href="#SERCH">
                <FontAwesomeIcon icon={faMagnifyingGlass} className="icon_font" />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>


    </>

  )
}

export default Header;